import React from 'react';
import { useLocation } from 'react-router-dom';
import { toJS } from 'mobx';
import { userAccountDataStore } from '../../stores/user_account_data_store';
import { mixpanelActions } from '../../utils/mixpanel_util';
import { amplitudeActions } from '../../utils/amplitude_util';

export const OpenInWindowButton = () => {
    const location = useLocation();
    const [showTooltip, setShowTooltip] = React.useState(false);

    const handleOpenInWindow = () => {
        // Track the action
        if (userAccountDataStore.user !== null && userAccountDataStore.user !== undefined) {
            mixpanelActions.track('Click', {
                location: 'Page',
                type: 'Open in New Window',
                user: toJS(userAccountDataStore.user),
            });
            amplitudeActions.track('Click', {
                location: 'Page',
                type: 'Open in New Window',
                user: toJS(userAccountDataStore.user),
            });
        }

        // Get the current full path including query parameters
        const currentPath = location.pathname + location.search;

        // Open in new window
        window.open(currentPath, '_blank');
    };

    return (
        <>
            <button
                onClick={handleOpenInWindow}
                style={{
                    position: 'fixed',
                    top: '70px',
                    right: '20px',
                    backgroundColor: 'teal',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    fontSize: '24px',
                    cursor: 'pointer',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    fontWeight: 'bold'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'teal';
                    e.target.style.transform = 'scale(1.1)';
                    e.target.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
                    setShowTooltip(true);
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'teal';
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                    setShowTooltip(false);
                }}
            >
                ⊞
            </button>
            {showTooltip && (
                <div
                    style={{
                        position: 'fixed',
                        top: '83px',
                        right: '80px',
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        fontSize: '14px',
                        whiteSpace: 'nowrap',
                        zIndex: 1001,
                        pointerEvents: 'none',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
                    }}
                >
                    Full screen display
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '-6px',
                            transform: 'translateY(-50%)',
                            width: 0,
                            height: 0,
                            borderTop: '6px solid transparent',
                            borderBottom: '6px solid transparent',
                            borderLeft: '6px solid rgba(0, 0, 0, 0.85)'
                        }}
                    />
                </div>
            )}
        </>
    );
};
